import React from 'react';
import { FiGithub, FiLinkedin, FiMail, FiPhone } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FiGithub />, href: 'https://github.com/manishmandal55', label: 'GitHub' },
    { icon: <FiLinkedin />, href: 'https://linkedin.com/in/manishmandal55', label: 'LinkedIn' },
    { icon: <FiMail />, href: 'mailto:manishmandal23232@gmail.com', label: 'Email' },
    { icon: <FiPhone />, href: 'tel:+9779705437508', label: 'Phone' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="footer-logo">
              <span className="logo-bracket">&lt;</span>
              Manish Mandal
              <span className="logo-bracket">/&gt;</span>
            </span>
            <p className="footer-tagline">Backend Developer</p>
          </div>

          <div className="footer-social">
            {socialLinks.map((link, index) => (
              <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className="social-link">
                {link.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Manish Mandal. Built with React & Node.js</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
